import { PreWraper } from '@components/shared/wraper/PreWraper'
import {
  BAR_COLORS,
  DISABLED_BAR_COLOR,
} from '@constants/buzzkuri/program-detail'

type Props = {
  text: string
  value: number
}

export const ProgramFeatureContentBarGraphItem = ({
  text,
  value,
}: Props): JSX.Element => (
  <div className="flex flex-row items-center lg:h-[2.2vw]">
    <div className="text-right">
      <PreWraper
        {...{ text }}
        classes="lg:text-[0.9vw] text-[#666666] text-[2.5vw]"
      />
    </div>
    <div className="flex flex-row ml-[1vw] lg:ml-[.6vw]">
      {BAR_COLORS.map((color, i) => (
        <div
          key={i}
          className={`lg:ml-[0.6vw] ml-[1vw] w-[2.5vw] h-[6vw] lg:w-[0.8vw] lg:h-[2.2vw] skew-x-[-16deg] ${
            value + 1 > i ? color : DISABLED_BAR_COLOR
          }`}
        />
      ))}
    </div>
  </div>
)
